export default __webpack_public_path__ + "static/media/loading.c96c983f.gif";